import { render, staticRenderFns } from "./DuelsGameStats.vue?vue&type=template&id=22264115&scoped=true"
import script from "./DuelsGameStats.vue?vue&type=script&lang=js"
export * from "./DuelsGameStats.vue?vue&type=script&lang=js"
import style0 from "./DuelsGameStats.vue?vue&type=style&index=0&id=22264115&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22264115",
  null
  
)

export default component.exports